<template>
  <div>
    <UnPatrolListComponent
      typeName="品質巡回 未点検一覧"
      :type="1"
      settionStrageName="UnpatrolListStorageItemName">
    </UnPatrolListComponent>
  </div>
</template>

<script>
import UnPatrolListComponent from '../components/UnPatrolListComponent.vue'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    UnPatrolListComponent
  },
}
</script>